/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import axios from "axios";
import { getColorListFromName } from 'molstar/lib/mol-util/color/lists';
import { WarningMessage } from '../Utils.js';
import { updateIsLoaded, updateIsActivated } from './HookStateUpdate.jsx';


export const loadStructuretoMolstar = async (plugin, urlfile, format, structure_id, database_format = "PDBe") => {
    //const isBinary = false;
    const filename = urlfile.substring(urlfile.lastIndexOf('/') + 1);
    const data = await plugin.builders.data.download({ url: urlfile, label: filename }, { state: { isGhost: true } });
    const trajectory = await plugin.builders.structure.parseTrajectory(data, format);
    const preset = await plugin.builders.structure.hierarchy.applyPreset(trajectory, "default");
    const structure = preset.structure;
    const components = {
        polymer: await plugin.builders.structure.tryCreateComponentStatic(structure, 'polymer'),
        ligand: await plugin.builders.structure.tryCreateComponentStatic(structure, 'ligand'),
        water: await plugin.builders.structure.tryCreateComponentStatic(structure, 'water'),
    };

    const builder = plugin.builders.structure.representation;
    let colormap = getColorListFromName('red-white-blue');
    let colorParams = { domain: [0, 100], list: { kind: 'set', colors: colormap.list } }
    if (database_format === "Alphafold") {
        colorParams.list.colors.reverse()
    }

    const update = plugin.build();
    if (components.polymer) builder.buildRepresentation(update, components.polymer, { type: 'cartoon', color: 'uncertainty' }, { tag: 'polymer' });
    if (components.ligand) builder.buildRepresentation(update, components.ligand, { type: 'ball-and-stick' }, { tag: 'ligand' });
    if (components.water) builder.buildRepresentation(update, components.water, { type: 'ball-and-stick' }, { tag: 'water' });
    await update.commit();

    var structurestorage = JSON.parse(sessionStorage.getItem('structures'));
    if (!structurestorage.hasOwnProperty(filename)) {
        structurestorage[filename] = { 'id': structure_id, 'trajectories': {} };
    }
    sessionStorage.setItem('structures', JSON.stringify(structurestorage));
    updateIsLoaded(true);
    updateIsActivated(true);
};

export const AxiosLoadStructuretoMolstar = async (plugin, formData, format, database_format = "PDBe") => {
    try {
        await axios({
            method: "post",
            url: "/api/structure/",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        }).then(
            function (response) {
                loadStructuretoMolstar(plugin, response.data.file, format, response.data.id, database_format);
            }
        );
    } catch (error) {
        WarningMessage(error)
    }
}
